import axiosClient from '../axiosClient';

export const getCommissions = (params) =>
  axiosClient.get('/admin/commissions', { params });

export const updateCommissionSettings = (data) =>
  axiosClient.put('/admin/commissions/settings', data);

export const getCommissionOverrides = (params) =>
  axiosClient.get('/admin/commissions/overrides', { params });
